import React, { useContext } from 'react'
import ContentHeader from '@Components/ContentHeader'
import RightsholderRoyaltiesContentHeader from '@Scenes/RightsholderScene/RightsholderRoyalties/RightsholderRoyaltiesHead/RightsholderRoyaltiesContentHeader'
import SelectComponent, { SelectOption } from '@Components/Selectors/Select'
import { observer } from 'mobx-react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { Maybe } from '@Types'

interface RightsholderRoyaltiesHeadProps {
    usagePeriod: Maybe<SelectOption>
    setUsagePeriod: (usagePeriod: SelectOption) => void
}

const RightsholderRoyaltiesHead = (props: RightsholderRoyaltiesHeadProps) => {
    const { statementsStore } = useContext<RootStore>(StoresContext)
    const { usagePeriod, setUsagePeriod } = props

    return (
        <div className="head-block">
            <ContentHeader title="Royalties" descriptionElement={<RightsholderRoyaltiesContentHeader />} />
            <div className="filter-block">
                <div className="filter-item-wrapper">
                    <div className="filter-item">
                        <p className="small bold">Distribution Period:</p>
                        <SelectComponent
                            options={statementsStore.royaltiesUsagePeriodOptions}
                            selectedValue={usagePeriod}
                            defaultValue={statementsStore.royaltiesUsagePeriodOptions[0]}
                            onValueChange={(selectOption) => selectOption && setUsagePeriod(selectOption)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(RightsholderRoyaltiesHead)
